/* sm-testimonials — Swiper (1.05/10 mobile, auto/20 desktop) + play -> video lightbox (X, backdrop, Escape) */
(function () {
  function init(root) {
    if (root.dataset.smInit || !window.Swiper) return;
    root.dataset.smInit = '1';
    var el = root.querySelector('[data-sm-slider]');
    var swiper = new window.Swiper(el, {
      slidesPerView: 1.05,
      spaceBetween: 10,
      navigation: { nextEl: root.querySelector('[data-sm-next]'), prevEl: root.querySelector('[data-sm-prev]') },
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { prevSlideMessage: 'Previous testimonial', nextSlideMessage: 'Next testimonial' },
      breakpoints: { 750: { slidesPerView: 'auto', spaceBetween: 20 } },
      preventInteractionOnTransition: true
    });
    root.smSwiper = swiper;

    var lb = root.querySelector('[data-sm-lightbox]');
    var content = lb && lb.querySelector('[data-sm-lightbox-content]');
    var lastFocus = null;
    function open(url, poster) {
      if (!lb || !url) return;
      var v = document.createElement('video');
      v.src = url; v.controls = true; v.autoplay = true; v.playsInline = true; if (poster) v.poster = poster;
      content.innerHTML = ''; content.appendChild(v);
      lb.hidden = false;
      requestAnimationFrame(function () { lb.classList.add('is-active'); });
      document.body.style.overflow = 'hidden';
      lastFocus = document.activeElement;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      var closeBtn = lb.querySelector('.sm-testimonials__lightbox-close'); if (closeBtn) closeBtn.focus();
    }
    function close() {
      if (!lb || lb.hidden) return;
      var v = content.querySelector('video'); if (v) { v.pause(); }
      lb.classList.remove('is-active');
      setTimeout(function () { lb.hidden = true; content.innerHTML = ''; }, 300);
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-sm-play]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var wrap = btn.closest('.sm-testimonials__video');
        open(wrap.dataset.smVideoUrl, wrap.dataset.smPoster);
      });
    });
    if (lb) {
      lb.querySelectorAll('[data-sm-lightbox-close]').forEach(function (c) { c.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lb.hidden) close(); });
    }
    root.smLightbox = { open: open, close: close };
  }
  function boot() { document.querySelectorAll('[data-sm-testimonials]').forEach(init); }
  function ready() { if (window.Swiper) boot(); else { var t = 0, iv = setInterval(function () { if (window.Swiper || ++t > 50) { clearInterval(iv); boot(); } }, 100); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
